<div class="color-bar"></div>
<app-loading [exibir]="carregando"></app-loading>
<div class="m-2">
  <button translate pButton type="button" class="p-button-raised p-button-warning p-button-sm" (click)="showDialog()">
    <i class="fa fa-filter mr-1"></i>{{'vorPCA.filter'}}
  </button>

  <button pButton type="button" class="p-button-outlined p-button-secondary p-button-sm pull-right"
    (click)="showDialogExport()">
    <i class="fa fa-download mr-1"></i>Export Passagens - CSV
  </button>

  <button *ngIf="marcas == 'GAC'" pButton type="button"
    class="p-button-outlined p-button-secondary p-button-sm pull-right mr-1"
    (click)="showDialogExportDetalhado()">
    <i class="fa fa-download mr-1"></i>Export Passagens Detalhado
  </button>

  <button translate pButton type="button" class="p-button-raised p-button-secondary p-button-sm ml-1"
    (click)="getAll()">
    <i class="fas fa-search mr-1"></i>{{'vorPCA.buscarDados'}}
  </button>
  <button pButton type="button" class="p-button-outlined p-button-secondary p-button-sm pull-right mr-1 ml-1"
    (click)="exportarExcel()">
    <i class="fa fa-download mr-1"></i>Export Excel
  </button>

  <button *ngIf="marcas == 'Volvo'" pButton type="button"
    class="p-button-outlined p-button-secondary p-button-sm pull-right mr-1" (click)="showDialogExportOneVoiceCsv()">
    <i class="fa fa-download mr-1"></i>Export Relatório One Voice
  </button>
</div>

<div class=" table-scroll" *ngIf="!carregando">
  <div class="container-fluid content">    
    <table class="table table-bordered table-striped table-hover" id="excel-table">
      <thead class="thead-dark">
        <tr>
          <th translate class="header-float row-float-total row-table-head">
            {{'rmpv.analisePassagem.titulo'}}
          </th>
          <th translate class="text-right header-float">
            {{'rmpv.analisePassagem.meses.jan'}}
          </th>
          <th translate class="text-right header-float">
            {{'rmpv.analisePassagem.meses.fev'}}
          </th>
          <th translate class="text-right header-float">
            {{'rmpv.analisePassagem.meses.mar'}}
          </th>
          <th translate class="text-right header-float">
            {{'rmpv.analisePassagem.meses.abr'}}
          </th>
          <th translate class="text-right header-float">
            {{'rmpv.analisePassagem.meses.mai'}}
          </th>
          <th translate class="text-right header-float">
            {{'rmpv.analisePassagem.meses.jun'}}
          </th>
          <th translate class="text-right header-float">
            {{'rmpv.analisePassagem.meses.jul'}}
          </th>
          <th translate class="text-right header-float">
            {{'rmpv.analisePassagem.meses.ago'}}
          </th>
          <th translate class="text-right header-float">
            {{'rmpv.analisePassagem.meses.set'}}
          </th>
          <th translate class="text-right header-float">
            {{'rmpv.analisePassagem.meses.out'}}
          </th>
          <th translate class="text-right header-float">
            {{'rmpv.analisePassagem.meses.nov'}}
          </th>
          <th translate class="text-right header-float">
            {{'rmpv.analisePassagem.meses.dez'}}
          </th>
          <th class="text-right header-float">
            Total
          </th>
          <th class="text-right header-float">
            % Total
          </th>
          <th class="text-right header-float">
            Total {{lastYearGrid - 1}}
          </th>
          <th class="text-right header-float">
            Total {{lastYearGrid - 2}}
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- PASSAGEM EXTERNO -->
        <tr *ngFor="let categoria of dados.passagem_externo.linhas">
          <!-- <td class="row-float">{{categoria.descricao}}</td> -->
          <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
          <td class="text-right">{{categoria.mes_01 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_02 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_03 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_04 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_05 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_06 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_07 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_08 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_09 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_10 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_11 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_12 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.total_ano | number: '1.0-0'}}</td>
          <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
          <td class="text-right">{{categoria.total_ano_anterior | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>
        <tr>
          <td translate class="dark-row row-float-total">{{'rmpv.analisePassagem.totalPassagensClientesExternos'}}</td>
          <td class="text-right dark-row">{{dados.passagem_externo.total.mes_01 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.passagem_externo.total.mes_02 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.passagem_externo.total.mes_03 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.passagem_externo.total.mes_04 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.passagem_externo.total.mes_05 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.passagem_externo.total.mes_06 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.passagem_externo.total.mes_07 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.passagem_externo.total.mes_08 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.passagem_externo.total.mes_09 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.passagem_externo.total.mes_10 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.passagem_externo.total.mes_11 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.passagem_externo.total.mes_12 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.passagem_externo.total.total_ano | number: '1.0-0'}}</td>
          <td class="text-right dark-row percentual">{{dados.passagem_externo.total.percentual | percent: '1.1'}}
          </td>
          <td class="text-right dark-row">{{dados.passagem_externo.total.total_ano_anterior | number: '1.0-0'}}
          </td>
          <td class="text-right dark-row">{{dados.passagem_externo.total.total_ano_retrasado | number: '1.0-0'}}
          </td>
        </tr>
        <!-- PASSAGEM INTERNO -->
        <tr *ngFor="let categoria of dados.passagem_interno.linhas">
          <!-- <td class="row-float">{{categoria.descricao}}</td> -->
          <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
          <td class="text-right">{{categoria.mes_01 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_02 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_03 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_04 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_05 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_06 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_07 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_08 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_09 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_10 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_11 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_12 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.total_ano | number: '1.0-0'}}</td>
          <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
          <td class="text-right">{{categoria.total_ano_anterior | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>
        <!-- TOTAL DE PASSAGENS -->
        <tr>
          <td [translate]="getTranslate(dados.total_passagens.descricao)" class="dark-row row-float-total"></td>
          <td class="text-right dark-row">{{dados.total_passagens.mes_01 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.total_passagens.mes_02 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.total_passagens.mes_03 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.total_passagens.mes_04 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.total_passagens.mes_05 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.total_passagens.mes_06 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.total_passagens.mes_07 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.total_passagens.mes_08 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.total_passagens.mes_09 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.total_passagens.mes_10 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.total_passagens.mes_11 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.total_passagens.mes_12 | number: '1.0-0'}}</td>
          <td class="text-right dark-row">{{dados.total_passagens.total_ano | number: '1.0-0'}}</td>
          <td class="text-right dark-row percentual">{{dados.total_passagens.percentual | percent: '1.1'}}
          </td>
          <td class="text-right dark-row">{{dados.total_passagens.total_ano_anterior | number: '1.0-0'}}
          </td>
          <td class="text-right dark-row">{{dados.total_passagens.total_ano_retrasado | number: '1.0-0'}}
          </td>
        </tr>
        <!-- PASSAGEM AGENDADA -->
        <tr *ngFor="let categoria of dados.passagem_agendada.linhas | slice:0:1">
          <!-- <td class="row-float">{{categoria.descricao}}</td> -->
          <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
          <td class="text-right">{{categoria.mes_01 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_02 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_03 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_04 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_05 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_06 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_07 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_08 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_09 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_10 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_11 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_12 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.total_ano | number: '1.0-0'}}</td>
          <td class="text-right percentual">{{1 | percent: '1.1'}}</td>
          <!-- <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td> -->
          <td class="text-right">{{categoria.total_ano_anterior | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>
        <!-- % AGENDAMENTO -->
        <tr>
          <td [translate]="getTranslate(dados.percentual_agendamento.descricao)" class="row-float"></td>
          <td class="text-right percentual">{{dados.percentual_agendamento.mes_01 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento.mes_02 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento.mes_03 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento.mes_04 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento.mes_05 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento.mes_06 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento.mes_07 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento.mes_08 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento.mes_09 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento.mes_10 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento.mes_11 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento.mes_12 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento.total_ano | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento.percentual | percent: '1.1'}}
          </td>
          <td class="text-right percentual">{{dados.percentual_agendamento.total_ano_anterior | percent: '1.1'}}
          </td>
          <td class="text-right percentual">{{dados.percentual_agendamento.total_ano_retrasado | percent: '1.1'}}
          </td>
        </tr>
        <!-- PASSAGEM AGENDADA FORMA ATIVA -->
        <tr *ngFor="let categoria of dados.passagem_agendada.linhas | slice:1:2">
          <!-- <td class="row-float">{{categoria.descricao}}</td> -->
          <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
          <td class="text-right">{{categoria.mes_01 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_02 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_03 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_04 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_05 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_06 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_07 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_08 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_09 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_10 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_11 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_12 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.total_ano | number: '1.0-0'}}</td>
          <td class="text-right percentual">{{1 | percent: '1.1'}}</td>
          <!-- <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td> -->
          <td class="text-right">{{categoria.total_ano_anterior | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>
        <!-- % AGENDAMENTO ATIVO -->
        <tr>
          <td [translate]="getTranslate(dados.percentual_agendamento_ativo.descricao)" class="row-float"></td>
          <td class="text-right percentual">{{dados.percentual_agendamento_ativo.mes_01 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento_ativo.mes_02 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento_ativo.mes_03 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento_ativo.mes_04 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento_ativo.mes_05 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento_ativo.mes_06 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento_ativo.mes_07 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento_ativo.mes_08 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento_ativo.mes_09 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento_ativo.mes_10 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento_ativo.mes_11 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento_ativo.mes_12 | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento_ativo.total_ano | percent: '1.1'}}</td>
          <td class="text-right percentual">{{dados.percentual_agendamento_ativo.percentual | percent: '1.1'}}
          </td>
          <td class="text-right percentual">{{dados.percentual_agendamento_ativo.total_ano_anterior | percent: '1.1'}}
          </td>
          <td class="text-right percentual">{{dados.percentual_agendamento_ativo.total_ano_retrasado | percent: '1.1'}}
          </td>
        </tr>
        <!-- O.S. ABERTO -->
        <tr *ngFor="let categoria of dados.os_aberto.linhas">
          <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
          <td class="text-right">{{categoria.mes_01 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_02 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_03 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_04 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_05 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_06 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_07 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_08 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_09 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_10 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_11 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_12 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.total_ano | number: '1.0-0'}}</td>
          <td class="text-right percentual">{{1 | percent: '1.1'}}</td>
          <!-- <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td> -->
          <td class="text-right">{{categoria.total_ano_anterior | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>
        <!-- QUANTIDADE BOXES -->
        <tr *ngFor="let categoria of dados.quantidade_boxes.linhas">
          <!-- <td class="row-float">{{categoria.descricao}}</td> -->
          <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
          <td class="text-right">{{categoria.mes_01 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_02 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_03 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_04 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_05 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_06 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_07 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_08 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_09 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_10 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_11 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.mes_12 | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.total_ano | number: '1.0-0'}}</td>
          <td class="text-right percentual">{{1 | percent: '1.1'}}</td>
          <!-- <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td> -->
          <td class="text-right">{{categoria.total_ano_anterior | number: '1.0-0'}}</td>
          <td class="text-right">{{categoria.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>
        <tr>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
          <td>...</td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>


<!--dialogs-->
<ng-container>
  <p-dialog styleClass="top-dialog" [(visible)]="display" [modal]="true" [draggable]="true" [resizable]="false"
    [contentStyle]="{'overflow': 'visible'}">
    <ng-template pTemplate="header">
      <h5 translate class="modal-title">{{'rmpv.analisePassagem.filtros.definirFiltros'}}</h5>
    </ng-template>
    <ng-template pTemplate="body">
      <!-- [formGroup]="form" -->
      <form>
        <div class="container striped-rows">
          <div class="row ptb5">
            <div class="col col-4">
              Mercado
            </div>
            <div class="col col-8">
              <ng-container>
                <p-dropdown appendTo="body" translate name="mercado"
                  placeholder="{{'rmpv.analisePassagem.filtros.mercadoPlaceHolder' | translate}}" [options]="mercados"
                  [(ngModel)]="filtros.mercado" optionLabel="descricao" optionValue="id" [style]="{'minWidth':'100%'}">
                </p-dropdown>
              </ng-container>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'rmpv.analisePassagem.filtros.grupoEconomico'}}
            </div>
            <div class="col col-8">
              <ng-container>
                <p-dropdown appendTo="body" name="grupo_economico"
                  placeholder="{{'rmpv.analisePassagem.filtros.grupoEconomicoPlaceHolder' | translate }}"
                  [options]="gruposEconomicos" [(ngModel)]="filtros.grupo_economico" optionLabel="descricao"
                  optionValue="id" [style]="{'minWidth':'100%'}" (onChange)="preencherDealers()"></p-dropdown>
              </ng-container>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'rmpv.analisePassagem.filtros.regiao'}}
            </div>
            <div class="col col-8">
              <ng-container>
                <p-dropdown appendTo="body" name="regiao"
                  placeholder="{{'rmpv.analisePassagem.filtros.regiaoPlaceHolder' | translate }}" [options]="regioes"
                  [(ngModel)]="filtros.regiao" optionLabel="descricao" optionValue="id" [style]="{'minWidth':'100%'}">
                </p-dropdown>
              </ng-container>
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              Dealers
            </div>
            <div class="col col-8">
              <ng-container>
                <p-dropdown appendTo="body" name="dealer"
                  placeholder="{{'rmpv.analisePassagem.filtros.dealerPlaceHolder' | translate }}" [options]="dealers"
                  [(ngModel)]="filtros.dealer" optionLabel="descricao" optionValue="id" [style]="{'minWidth':'100%'}">
                </p-dropdown>
              </ng-container>
            </div>
          </div>
          <div class="row ptb5" *ngIf="isFilterTable">
            <div translate class="col col-4">
              {{'rmpv.analisePassagem.filtros.mesInicial'}}
            </div>
            <div class="col col-8">
              <ng-container>
                <p-dropdown appendTo="body" name="mes_inicial"
                  placeholder="{{'rmpv.analisePassagem.filtros.mesInicial' | translate }}" [options]="meses"
                  [(ngModel)]="filtros.mes_inicial" optionLabel="header" optionValue="field"
                  [style]="{'minWidth':'100%'}">
                </p-dropdown>
              </ng-container>
            </div>
          </div>
          <div class="row ptb5" *ngIf="isFilterTable">
            <div translate class="col col-4">
              {{'rmpv.analisePassagem.filtros.mesFinal'}}
            </div>
            <div class="col col-8">
              <ng-container>
                <p-dropdown appendTo="body" name="mes_final"
                  placeholder="{{'rmpv.analisePassagem.filtros.mesFinal' | translate }}" [options]="meses"
                  [(ngModel)]="filtros.mes_final" optionLabel="header" optionValue="field" [style]="{'minWidth':'100%'}"
                  [translate]="getTranslate(header)">
                </p-dropdown>
              </ng-container>
            </div>
          </div>
          <div class="row ptb5" *ngIf="isFilterTable">
            <div translate class="col col-4">
              {{'rmpv.analisePassagem.filtros.ano'}}
            </div>
            <div class="col col-8">
              <ng-container>
                <p-dropdown appendTo="body" name="ano" placeholder="{{'rmpv.analisePassagem.filtros.ano' | translate }}"
                  [options]="anos" [(ngModel)]="filtros.ano" optionLabel="field" optionValue="field"
                  [style]="{'minWidth':'100%'}">
                </p-dropdown>
              </ng-container>
            </div>
          </div>
          <div class="row ptb5" *ngIf="isExportPassagens || isExportPassagensDetalhado || isExportOneVoice">
            <div translate class="col col-4">
              {{'rmpv.analisePassagem.filtros.dataInicial'}}
            </div>
            <div class="col col-8">
              <ng-container>
                <p-calendar placeholder="{{'rmpv.analisePassagem.filtros.dataInicialPlaceHolder' | translate}}"
                  appendTo="body" [(ngModel)]="data_inicial" dateFormat="dd/mm/yy" [showIcon]="true"
                  [style]="{'minWidth':'100%'}">
                </p-calendar>
              </ng-container>
            </div>
          </div>
          <div class="row ptb5" *ngIf="isExportPassagens || isExportPassagensDetalhado || isExportOneVoice">
            <div translate class="col col-4">
              {{'rmpv.analisePassagem.filtros.dataFinal'}}
            </div>
            <div class="col col-8">
              <ng-container>
                <p-calendar placeholder="{{'rmpv.analisePassagem.filtros.dataFinalPlaceHolder' | translate}}"
                  appendTo="body" [(ngModel)]="data_final" dateFormat="dd/mm/yy" [showIcon]="true"
                  [style]="{'minWidth':'100%'}">
                </p-calendar>
              </ng-container>
            </div>
          </div>
          <div class="row ptb5" *ngIf="isExportPassagens || isExportPassagensDetalhado">
            <div translate class="col col-4">
              {{'rmpv.analisePassagem.filtros.partNumber'}}
            </div>
            <div class="col col-8">
              <ng-container>
                <input pInputText type="text" class="p-inputtext-sm" style="min-width: 100%;"
                  placeholder="{{'rmpv.analisePassagem.filtros.partNumberPlaceHolder' | translate}}"
                  [(ngModel)]="filtros.part_number" name="part_number">
              </ng-container>
            </div>
          </div>
        </div>
      </form>
    </ng-template>
    <ng-template pTemplate="footer">
      <button *ngIf="isExportOneVoice" type="button" class="btn btn-info mt-1 pull-right"
        (click)="exportOneVoiceCsv()">OK</button>
      <button *ngIf="isExportPassagens" type="button" class="btn btn-info mt-1 pull-right"
        (click)="exportPassagensCsv()">OK</button>
      <button *ngIf="isExportPassagensDetalhado" type="button" class="btn btn-info mt-1 pull-right"
        (click)="exportPassagensDetalhadoCsv()">OK</button>
      <button *ngIf="isFilterTable" type="button" class="btn btn-info mt-1 pull-right" (click)="getAll()">OK</button>
      <button type="button" class="btn btn-outline-secondary mt-1 pull-right mr-1" (click)="cleanFilter()"><i
          class="fa fa-trash" aria-hidden="true"></i></button>
    </ng-template>
  </p-dialog>
</ng-container>